import { DISCOUNT_CATEGORY } from '~~/types/discounts';
import type { MappedDiscount } from '~~/types/discounts';
import { getCartDiscounts } from '~~/helpers/cart/cartDiscountGetter';

/**
 * The distinct products discount is proposed as an unlockable saving as long as
 * it is configured in commercetools and not already applied to the cart.
 */
export const useInactiveDistinctProductsDiscount = () => {

  const { cart } = useCartExtended();
  const { lineItems } = useLineItems();
  const { distinctProductsDiscount } = useDistinctProductsDiscount();

  const isDistinctProductsDiscountActive = computed(() => {

    return getCartDiscounts(cart.value)
      .some(discount => discount.category === DISCOUNT_CATEGORY.DISTINCT_PRODUCTS);

  });

  const inactiveDistinctProductsDiscount = computed<MappedDiscount | null>(() => {

    if (!distinctProductsDiscount.value || !lineItems.value?.length) {

      return null;

    }

    if (isDistinctProductsDiscountActive.value) {

      return null;

    }

    return {
      id: 'inactive-distinct-products-discount',
      name: 'Multi-product discount',
      type: 'relative' as const,
      target: 'lineItems' as const,
      value: distinctProductsDiscount.value.discountPercentage,
      discountedAmount: 0,
      requiresDiscountCode: false,
      products: [],
      category: DISCOUNT_CATEGORY.DISTINCT_PRODUCTS,
      minimalQuantity: distinctProductsDiscount.value.minimalQuantity,
    };

  });

  return {
    isDistinctProductsDiscountActive,
    inactiveDistinctProductsDiscount,
  };

};
